import commTopComponent from './index.vue'

const commTop = {
  install: function (Vue) {
    Vue.component('CommTop', commTopComponent)
  }
}

export default commTop



// WEBPACK FOOTER //
// ./src/layout/index.js